/* src/app/menu/menu.component.css */
.main-nav ul li a {
  color: #2ad5dc;
}
.rotertext h1 {
  font-size: 40px;
  color: red;
}
.version {
  font-size: xx-small;
  text-align: left;
  position: absolute;
  bottom: 0px;
  left: 25px;
  z-index: 10000;
  color: #c6c6c6;
}
.version_blink {
  color: red;
  background-color: yellow;
  font-weight: bold;
  font-size: x-large;
  animation: blink 1s alternate infinite;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: .66;
  }
  100% {
    opacity: .3;
  }
}
.personal_verfuegbar {
  font-size: small;
  text-align: left;
  position: absolute;
  top: 00px;
  right: 20px;
  z-index: 10000;
  color: #55c606;
}
.personal {
  font-size: small;
  text-align: right;
  position: absolute;
  top: 00px;
  right: 0px;
  z-index: 10000;
  color: #c6c6c6;
}
.personal .da {
  color: #23c600;
}
.personal .nichtda {
  color: #c60002;
}
/*# sourceMappingURL=menu.component-PTHGA73F.css.map */
